// Bepaalt productscope uit feature-flags op CompagnyMeta.
// Volgorde: Portfolio > plan-only (alleen HouseVisits) > cvm-impact (default).
// Tolerant voor zowel boolean true als string 'true' (zie memory: ToggleButton type-drift).

const isTruthy = (v) => v === true || v === 'true';

const computeProductScope = (entity = {}) => {
    if (isTruthy(entity.Portfolio)) return 'portfolio';

    const hasImpact = isTruthy(entity.ImpactFunctionality);
    const hasPersonas = isTruthy(entity.Personas);
    const hasHouseVisits = isTruthy(entity.HouseVisits);

    if (hasHouseVisits && !hasImpact && !hasPersonas) return 'plan-only';

    return 'cvm-impact';
};

export default computeProductScope;
